import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DisputeCard from "assets/dispute_card.webp";
import LightBulb from "assets/lightbulb.svg";
import { CreditReportConsentModal } from "./CreditReportConsentModal";

const DISPUTE_TITLE = "Credit Report";

const CreditReportDispute = ({ className = "" }) => {
  const history = useHistory();
  const { roles } = useSelector((state) => state.user);
  const [consentModalOpen, setConsentModalOpen] = useState(false);
  const showCreditReportButton = roles.user_with_credit_monitoring_enrolled;

  const handleViewCreditReport = () => {
    if (roles.credit_report_enrolled || roles.credit_report_eligible) {
      // currently, these roles means user is both CMD and boost enrolled
      // redirect to credit report page
      setConsentModalOpen(true);
    } else {
      // to see this button, user is assumed to be enrolled in CMD
      // if goes to here (no credit_report_eligible role), user is not boost enrolled
      // TC-3754 - if not enrolled in boost=> send to Boost pricing page
      // open new window to boost landing pricing
      const pricingUrl = `${process.env.REACT_APP_DOMAIN}/boost-pricing`;
      window.open(pricingUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const handleConsentAgreed = () => {
    history.push("/credit-report");
  };

  const closeConsentModal = () => {
    setConsentModalOpen(false);
  };

  return (
    <div className={`${className} h-auto p-10 text-black`} style={{ letterSpacing: 0.1 }}>
      <CreditReportConsentModal
        onAgree={handleConsentAgreed}
        closeModal={closeConsentModal}
        modalOpen={consentModalOpen}
      />
      <p className="text-2xl font-bold">
        {DISPUTE_TITLE}
      </p>
      <div className="py-5 pl-5 md:pl-10 flex flex-col md:flex-row">
        <img
          src={DisputeCard}
          className="mx-12 md:ml-0 my-auto"
          style={{ width: 109, height: "auto" }}
          alt=""
        />
        <div className="mt-2 md:mt-0">
          <ul className="list-disc space-y-2">
            <li>Fast, free access to your credit report online</li>
            <li>Stay on top of your financial history</li>
            <li>Identify inaccuracies and negative marks</li>
          </ul>
          {showCreditReportButton && <div className="mt-4">
            <button
              type="button"
              className="bg-black hover:bg-neutral-600 active:bg-neutral-700 focus:outline-none px-4 py-1 text-white"
              disabled={!showCreditReportButton}
              onClick={handleViewCreditReport}
            >
              View credit report
            </button>
          </div>}
        </div>
      </div>
      <div className="py-5 px-10 flex flex-col bg-success-100 rounded-md">
        <span className="flex items-center font-bold" style={{ letterSpacing: -0.25 }}><img src={LightBulb} alt="" className="-ml-5 inline mr-1" />Find any inaccuracies?</span>
        <p className="mt-1">
          Coming soon - You can now dispute inaccuracies on your credit report directly on Credit Monitor.{" "}
          <button type="button" className="hidden underline focus:outline-none">Learn more</button>
        </p>
      </div>
    </div>
  );
};

export default CreditReportDispute;
